export abstract class AnalyticsAdapter {
  abstract setScreenName(name: string);

  abstract fireEvent(event: string, data: any);

  abstract fireBookingEvent(event: string, data: any);

  abstract setUserId(userId: string);
}
